import React, { useState } from 'react';
import { ALL_ROUTES } from '../../../../../../routes/dashboard/overview/AllPathNames';
import { useOnClickOutside } from '../../../../../../utils/helper/UseOnClickOutside';
import { useDarkMode } from '../../../../../../hooks/useDarkMode';
import { RavenTab } from '@ravenpay/raven-bank-ui';
import { colorToRgba } from '../../../../../../utils/helper/Helper';
import { useNavigate } from 'react-router-dom';

interface myComponentProps {
	activeTabIndex?: string;
	setActiveTabIndex?: (param?: any) => void;
}

const SingleMerchantTabLink = ({
	activeTabIndex,
	setActiveTabIndex,
}: myComponentProps) => {
	const [theme, toggleTheme] = useDarkMode(localStorage.getItem('theme'));
	// State to track the active tab index, initially set to the first tab

	// List of tabs

	const navigate = useNavigate();

	async function handleView(e: string) {
		// insert url param
		localStorage?.setItem('single-ter-serial', e);
		await navigate({
			pathname: ALL_ROUTES?.SINGLE_MERCHANT_VIEW_BANKBOX,
		});

		// append the query parameters
		// await insertUrlParam('serial', e, `Atlas: BankBox - SN:${e}`);
	}

	const listToUse = [
		{
			label: 'Transaction',
			active: activeTabIndex === ALL_ROUTES?.SINGLE_MERCHANT_TRANSACTION,
			value: ALL_ROUTES?.SINGLE_MERCHANT_TRANSACTION,
			onClick: () =>
				setActiveTabIndex &&
				setActiveTabIndex(ALL_ROUTES?.SINGLE_MERCHANT_TRANSACTION),
		},

		{
			label: 'Settlements',
			active: activeTabIndex === ALL_ROUTES?.SINGLE_MERCHANT_SETTLEMENTS,
			value: ALL_ROUTES?.SINGLE_MERCHANT_SETTLEMENTS,
			onClick: () =>
				setActiveTabIndex &&
				setActiveTabIndex(ALL_ROUTES?.SINGLE_MERCHANT_SETTLEMENTS),
		},

		{
			label: 'Terminals',
			active: activeTabIndex === ALL_ROUTES?.SINGLE_USER_TERMINAL,
			value: ALL_ROUTES?.SINGLE_USER_TERMINAL,
			onClick: () =>
				setActiveTabIndex &&
				setActiveTabIndex(ALL_ROUTES?.SINGLE_USER_TERMINAL),
			children: [
				{
					label: 'Physical Terminals',
					active: activeTabIndex === ALL_ROUTES?.SINGLE_USER_TERMINAL,
					value: ALL_ROUTES?.SINGLE_USER_TERMINAL,
					onClick: () =>
						setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.SINGLE_USER_TERMINAL),
				},
				{
					label: 'Virtual Terminals',
					active: activeTabIndex === ALL_ROUTES?.SINGLE_USER_VIRTUAL,
					value: ALL_ROUTES?.SINGLE_USER_VIRTUAL,
					onClick: () =>
						setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.SINGLE_USER_VIRTUAL),
				},
			],
		},
		{
			label: 'Biils',
			active: [
				ALL_ROUTES?.SINGLE_MERCHANT_BILLS_AIRTIME,
				ALL_ROUTES?.SINGLE_MERCHANT_BILLS_DATA,
				ALL_ROUTES?.SINGLE_MERCHANT_BILLS_CABLE,
				ALL_ROUTES?.SINGLE_MERCHANT_ElECTRICITY,
				ALL_ROUTES?.SINGLE_MERCHANT_BETTING,
			]?.includes(activeTabIndex as string),
			value: ALL_ROUTES?.SINGLE_MERCHANT_BILLS_AIRTIME,
			onClick: () =>
				setActiveTabIndex &&
				setActiveTabIndex(ALL_ROUTES?.SINGLE_MERCHANT_BILLS_AIRTIME),

			children: [
				{
					label: 'Airtime',
					active: activeTabIndex === ALL_ROUTES?.SINGLE_MERCHANT_BILLS_AIRTIME,
					value: ALL_ROUTES?.SINGLE_MERCHANT_BILLS_AIRTIME,
					onClick: () =>
						setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.SINGLE_MERCHANT_BILLS_AIRTIME),
				},
				{
					label: 'Data',
					active: activeTabIndex === ALL_ROUTES?.SINGLE_MERCHANT_BILLS_DATA,
					value: ALL_ROUTES?.SINGLE_MERCHANT_BILLS_DATA,
					onClick: () =>
						setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.SINGLE_MERCHANT_BILLS_DATA),
				},
				{
					label: 'Cable',
					active: activeTabIndex === ALL_ROUTES?.SINGLE_MERCHANT_BILLS_CABLE,
					value: ALL_ROUTES?.SINGLE_MERCHANT_BILLS_CABLE,
					onClick: () =>
						setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.SINGLE_MERCHANT_BILLS_CABLE),
				},
				{
					label: 'Electricity',
					active: activeTabIndex === ALL_ROUTES?.SINGLE_MERCHANT_ElECTRICITY,
					value: ALL_ROUTES?.SINGLE_MERCHANT_ElECTRICITY,
					onClick: () =>
						setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.SINGLE_MERCHANT_ElECTRICITY),
				},
				{
					label: 'Betting',
					active: activeTabIndex === ALL_ROUTES?.SINGLE_MERCHANT_BETTING,
					value: ALL_ROUTES?.SINGLE_MERCHANT_BETTING,
					onClick: () =>
						setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.SINGLE_MERCHANT_BETTING),
				},
			],
		},
		{
			label: 'Device Requests',
			active: activeTabIndex === ALL_ROUTES?.SINGLE_MERCHANT_DEVICE_REQUEST,
			value: ALL_ROUTES?.SINGLE_MERCHANT_DEVICE_REQUEST,
			onClick: () =>
				setActiveTabIndex &&
				setActiveTabIndex(ALL_ROUTES?.SINGLE_MERCHANT_DEVICE_REQUEST),
		},
		{
			label: 'Dispute',
			active: activeTabIndex === ALL_ROUTES?.SINGLE_MERCHANT_DISPUTE,
			value: ALL_ROUTES?.SINGLE_MERCHANT_DISPUTE,
			onClick: () =>
				setActiveTabIndex &&
				setActiveTabIndex(ALL_ROUTES?.SINGLE_MERCHANT_DISPUTE),
		},
		{
			label: 'Compliance',
			active: activeTabIndex === ALL_ROUTES?.COMPLIANCE_CARDLIST,
			path: ALL_ROUTES?.COMPLIANCE_CARDLIST,
			onClick: () =>
				setActiveTabIndex && setActiveTabIndex(ALL_ROUTES?.COMPLIANCE_CARDLIST),
		},
	];

	const [activeDrop, setActiveDrop] = useState<string>('');

	const testingSettingPreviewRef = useOnClickOutside(() => {
		setActiveDrop('');
	});

	return (
		<>
			{/* reusable tab start */}
			<RavenTab
				activeBgColor={colorToRgba('var(--primary-base-color)', 0.1)}
				activeColor="var(--primary-base-color)"
				list={listToUse}
				// showParentSelected
				style={{ marginTop: '0rem' }}
			/>
			{/* reusable tab end */}
		</>
	);
};

export default SingleMerchantTabLink;
